module.exports = __webpack_public_path__ + "static/media/mov-icon.b6d9d4b7.svg";